import template from './leave.html';
import controller from './leave.controller';

let leaveComponent = {
  bindings: {},
  template,
  controller,
  controllerAs: '$ctrl'
};

export default leaveComponent;




// WEBPACK FOOTER //
// ./client/pages/leave/leave.component.js